import { render, staticRenderFns } from "./NewAccountInputs.vue?vue&type=template&id=6fd30d66"
import script from "./NewAccountInputs.vue?vue&type=script&lang=js"
export * from "./NewAccountInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports